import { useFeature } from "../features";

export const useDashboardLayoutRedesignEnabled = (): boolean => {
  const { featureEnabled } = useFeature();
  return featureEnabled("enable_dashboard_layout_redesign");
};
